export const accessByOrganizationType = 'contactManagement.accessByOrganization';
export const orgPermissions = ['view-and-message-members', 'create-notifications', 'manage-members'];
export const accountSearchType = 'contactManagement.accountSearch';
